<template>
    <div class="inner-wrapper">
        <div class="alert alert-success" role="alert" v-if="successMessage">
            {{ successMessage }}
        </div>

        <!--<div class="page-title">
            <h1 class="float-left">Purchase Orders</h1>
            <div class="title-right float-right">

            </div>
        </div>-->
        <div class="new-rfq">
            <fieldset class="customer-search mb-3">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-auto">
                                <form class="form-inline list-search" action="">
                                    <div class="filter-sec">
                                        <button type="button" class="btn filter-btn" @click="toggleShowFilters">
                                            <i class="ri-filter-line align-bottom me-1"></i> Filters
                                        </button>
                                    </div>
                                    <span class="listbtn-sec">
                                        <a href="javascript:void(0)" class="btn list-btn"
                                        @click="isListView=true;"
                                        :class="{'active': isListView == true}"><i  class="ri-list-check align-bottom"></i></a>
                                        <a href="javascript:void(0)" class="btn list-btn"
                                        @click="isListView=false;"
                                        :class="{'active': isListView == false}"><i  class="ri-grid-fill align-bottom"></i></a>

                                    </span>
                                    <!--<router-link :to="{ name: 'purchaseSelectProducts'}" class="btn create-btn"><i class="fa fa-plus" aria-hidden="true"></i> Create Order</router-link>-->
                                </form>
                            </div>
                            <div class="col-lg-3 col-auto">
                                <form class="form-inline list-search" @submit.prevent="search">
                                    <div class="input-group">
                                        <div class="input-group-append">
                                            <button class="btn btn-success" type="button" @click.prevent="search"><i
                                                class="fa fa-search" aria-hidden="true"></i></button>
                                        </div>
                                        <input v-model="filterData.purchase_search" type="text" class="form-control"
                                            placeholder="Quick Search">

                                    </div>
                                </form>
                            </div>
                            <div class="col-auto ms-sm-auto">
                                <div  class="btnrow float-right">
                                    <div class="quotes-text" style="margin-top: 10px;">{{ totalOrders }} Orders</div>
                                </div>

                            </div>
                        </div>
                        <div class="filter-row" v-if="showFilters">
                            <div class="form-group">
                                <select class="form-control" v-model="filterData.search_status_Id" @change="search()">
                                    <option :value="null">Status</option>
                                    <option v-for="(status, index) in filters.po_statuses" :value="status.id">
                                        {{ status.name }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group">
                                <v-select label="text" :filterable="false"
                                        v-model="vendor"
                                        :options="vendors"
                                        placeholder="Vendor"
                                        @input="onVendorSelect"
                                        @search="onVendorSearch"
                                        @selected="onVendorSelect"
                                        @deselected="onVendorDeSelect">
                                    <template slot="no-options">
                                        type to search vendors..
                                    </template>
                                    <template slot="option" slot-scope="option">
                                        <div class="d-center" v-html="option.html">
                                        </div>
                                    </template>
                                    <template slot="selected-option" slot-scope="option">
                                        <div class="selected d-center" v-html="option.text">
                                        </div>
                                    </template>
                                </v-select>
                            </div>
                            <div class="form-group">
                                <select class="form-control" v-model="filterData.label_id" @change="search()">
                                    <option :value="null">Label</option>
                                    <option v-for="(item, index) in filters.labels" :value="item.id">
                                        {{ item.name }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group">
                                <select class="form-control" v-model="filterData.search_saleuser_id" @change="search()">
                                    <option :value="null">Sales REP</option>
                                    <option v-for="(sale_user, index) in filters.sale_users" :value="sale_user.id">
                                        {{ sale_user.name }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group">
                                <select class="form-control" v-model="filterData.search_added_user_id" @change="search()">
                                    <option :value="null">Added By</option>
                                    <option v-for="(admin_user, index) in filters.admin_users" :value="admin_user.id">
                                        {{ admin_user.name }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group">
                                <select class="form-control" v-model="filterData.search_by_date" @change="search()">
                                    <option :value="null">Time Frame</option>
                                    <option value="0">All Time</option>
                                    <option value="1">Today</option>
                                    <option value="2">This week</option>
                                    <option value="3">This Month</option>
                                    <option value="4"> This Year</option>
                                    <option value="5">Custom Range</option>
                                </select>
                            </div>
                            <div class="search-btnsec dl-flex">
                                <button class="btn btn-success" type="button" @click.prevent="search"><i class="ri-search-line search-icon"></i>
                                </button>
                                <button class="btn btn-reset" type="button" @click="resetFilter"><i class="ri-refresh-line"></i>
                                </button>
                            </div>
                        </div>
                        <div class="row" v-if="showFilters">
                            <div class="col-md-3">
                                <date-picker v-if="filterData.search_by_date == 5" format="MM/DD/YYYY" @change="search()"
                                            v-model="filterData.date_range" range></date-picker>
                            </div>
                        </div>
                    </div>
                </div>
            </fieldset>

            <template v-if="isListView">
                <PurchaseOrderList :filterData="filterData" :is_draft="0"
                                   :bus="bus" ref="orderList"
                                   @returnTotalNumOrders="setTotalOrders" @deleteItem="removeItem" @onDeleteMultiple="deleteMultiple"></PurchaseOrderList>
            </template>
            <template v-else>
                <PurchaseOrderGrid :filterData="filterData"
                                   :bus="bus" ref="orderGrid"
                                   @returnTotalNumOrders="setTotalOrders" @deleteItem="removeItem"></PurchaseOrderGrid>
            </template>


        </div>

        <footer class="footer">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-sm-6">
                        2022 © Superb.
                    </div>
                    <div class="col-sm-6">
                        <div class="text-right d-none d-sm-block">
                            All Rights Reserved.
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";

import PurchaseOrderList from "../../components/PurchaseOrderList";
import PurchaseOrderGrid from "../../components/PurchaseOrderGrid";
import Vue from "vue";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
    name: "Orders",
    components: {
        DatePicker,
        PurchaseOrderList, PurchaseOrderGrid
    },
    created() {
        this.getOrderFilters();
    },
    beforeMount() {
        let statusId = localStorage.getItem('poFilterStatus');
        if (typeof statusId != undefined && statusId != null && statusId != '') {
            this.filterData.search_status_Id = statusId;
            localStorage.removeItem('poFilterStatus');
        }
    },
    data() {
        return {
            bus: new Vue(),
            isListView: false,
            totalOrders: 0,
            showFilters: false,
            filters: {
                statuses: [],
                po_statuses: [],
                sale_users: [],
                admin_users: [],
                labels: []
            },
            filterData: {
                purchase_search: null,
                search_saleuser_id: null,
                search_vendor_id: null,
                search_added_user_id: null,
                search_by_date: null,
                search_status_Id: null,
                date_range: null,
                label_id: null
            },
            vendors: [],
            vendor: null
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setLoading',
            'setPurchaseOrdersShowFilters',
            'setPurchaseOrdersFilterData'
        ]),
        resetFilter() {
            this.filterData = {
                purchase_search: null,
                search_saleuser_id: null,
                search_vendor_id: null,
                search_added_user_id: null,
                search_by_date: null,
                search_status_Id: null,
                date_range: null,
                label_id: null
            };
            this.setPurchaseOrdersFilterData(this.filterData);
            this.vendor = null;
            this.search();
        },
        toggleShowFilters(){
            this.showFilters = !this.showFilters;

            this.setPurchaseOrdersFilterData(this.showFilters);
        },
        removeItem(event) {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.delete(window.route('purchase-orders.destroy', {id: event.id}), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        self.bus.$emit('resetOrderDeleteSelection');
                        self.bus.$emit('getOrders');
                        self.setSuccessMessage(data.message);
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        deleteMultiple(selectedOrdersForDelete){
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.post(window.route('po.deleteSelectedOrders'), {ids: selectedOrdersForDelete}, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        self.bus.$emit('getOrders');
                        self.setSuccessMessage(data.message);
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        search() {
            this.bus.$emit('getOrders')
        },
        getOrderFilters() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('orders.getFilters'), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors && data.errors.length) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.filters = data.data;
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        setTotalOrders(event) {
            this.totalOrders = event;
        },
        onVendorSelect(event) {
            if (event) {
                this.filterData.search_vendor_id = event.id;
            } else {
                this.filterData.search_vendor_id = null;
            }
            this.search();
        },
        onVendorDeSelect(event) {
            this.filterData.search_vendor_id = null;
            this.search();
        },
        onVendorSearch(search, loading) {
            if (search.length) {
                loading(true);
                this.searchVendorNew(loading, search, this);
            }
        },
        searchVendorNew: _.debounce((loading, search, vm) => {
            return axios.post(window.route('searchVendors'), {searchTerm: search}, {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {

                    } else {
                        vm.vendors = data.data;
                    }
                })
                .catch((error) => {

                })
                .finally(() => {
                    //self.setLoading(false);
                    loading(false);
                });
        }, 350),

    },
    watch: {
        '$route.query.status'() {
            this.filterData.status_search = this.$route.query.status;
            this.search();
        },
        filterData: {
            handler: function (after, before) {
                this.setPurchaseOrdersFilterData(after);
            },
            deep: true,
        },
    },
    mounted() {
        if(this.purchaseOrderState) {
            this.showFilters = this.purchaseOrderState.showFilters;
            this.filterData = _.cloneDeep(this.purchaseOrderState.filterData);
        }
        let self = this;
        this.$root.$on('changePOStatusFilter', (statusId) => {
            self.showFilters = self.purchaseOrderState.showFilters;
            self.filterData = _.cloneDeep(self.purchaseOrderState.filterData);

            if (typeof statusId != undefined && statusId != '') {
                self.filterData.search_status_Id = statusId;
                self.showFilters = true;
                self.search();
            }
        });
        if (this.$route.query.status) {
            this.filterData.status_search = this.$route.query.status;
            this.search();
        }
    },
    computed: {
        ...mapState([
            'userState',
            'purchaseOrderState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
        ])
    }
}
</script>

<style scoped>

</style>
